(function () {
  'use strict';

  // "Secim yok" anlamina gelen secenek degeri. Magazada tek bir yazim standardi
  // yok: "None" yaninda "No Accessories" / "No accessories" da kullaniliyor ve
  // hepsi ayni seyi ifade ediyor. Kelime basina bakiyoruz, boylece "Nordic Star"
  // gibi gercek bir aksesuar degeri yanlislikla "yok" sayilmaz.
  function themeIsNoneValue(value) {
    var v = (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    if (v === '' || v === 'none' || v === 'yok' || v === 'gerekmez') return true;
    // "Not Required" / "Not required" da "secim yok" demek; magazada bu yazim da var.
    if (v === 'not required' || v === 'not requred' || v === 'not needed') return true;
    return v.split(' ')[0] === 'no';
  }

  function themeFormatMoney(cents) {
    var format = window.themeMoneyFormat || '{{amount}}';
    var value = cents / 100;

    function withDelimiters(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? parts.join(decimal) : parts[0];
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, placeholder) {
      switch (placeholder) {
        case 'amount_no_decimals':
          return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(value, 0, '.', ',');
        default:
          return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  var drawerOpenBtn = document.querySelector('[data-drawer-open]');
  var drawerTimer;

  function openDrawer() {
    if (!drawer) return;
    clearTimeout(drawerTimer);
    drawer.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
    });
    document.body.style.overflow = 'hidden';
    if (drawerOpenBtn) drawerOpenBtn.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    drawerTimer = setTimeout(function () {
      drawer.hidden = true;
    }, 360);
    document.body.style.overflow = '';
    if (drawerOpenBtn) drawerOpenBtn.setAttribute('aria-expanded', 'false');
  }

  if (drawerOpenBtn) drawerOpenBtn.addEventListener('click', openDrawer);
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  /* ---------- Fullscreen live search ---------- */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var closeSearch = function () {};

  if (searchOverlay) {
    var searchInput = searchOverlay.querySelector('[data-search-input]');
    var searchHint = searchOverlay.querySelector('[data-search-hint]');
    var searchResults = searchOverlay.querySelector('[data-search-results]');
    var searchGrid = searchOverlay.querySelector('[data-search-grid]');
    var searchEmpty = searchOverlay.querySelector('[data-search-empty]');
    var searchAll = searchOverlay.querySelector('[data-search-all]');
    var searchPageUrl = searchOverlay.dataset.searchUrl || '/search';
    var suggestUrl = (searchOverlay.dataset.suggestUrl || '/search/suggest') + '.json';
    var searchTimer2;
    var overlayTimer;

    var openSearch = function () {
      closeDrawer();
      clearTimeout(overlayTimer);
      searchOverlay.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          searchOverlay.classList.add('is-open');
        });
      });
      document.body.style.overflow = 'hidden';
      if (searchInput) searchInput.focus();
    };

    closeSearch = function () {
      if (searchOverlay.hidden) return;
      searchOverlay.classList.remove('is-open');
      overlayTimer = setTimeout(function () {
        searchOverlay.hidden = true;
      }, 300);
      document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });

    var searchCloseBtn = searchOverlay.querySelector('[data-search-close]');
    if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function formatSuggestPrice(price) {
      var num = parseFloat(price);
      if (isNaN(num)) return '';
      return num.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function renderResults(products, query) {
      if (!products.length) {
        searchResults.hidden = true;
        searchEmpty.hidden = false;
        return;
      }

      searchGrid.innerHTML = products.map(function (product) {
        var imgUrl = product.featured_image && product.featured_image.url ? product.featured_image.url : '';
        if (imgUrl) {
          imgUrl += (imgUrl.indexOf('?') === -1 ? '?' : '&') + 'width=540';
        }
        var img = imgUrl
          ? '<img src="' + imgUrl + '" alt="" loading="lazy" width="540" height="720">'
          : '';
        var price = product.price ? formatSuggestPrice(product.price) : '';
        return (
          '<a class="search-result" href="' + product.url + '">' +
            '<div class="search-result__media">' + img + '</div>' +
            '<p class="search-result__title">' + escapeHtml(product.title) + '</p>' +
            (price ? '<span class="search-result__price">' + price + '</span>' : '') +
          '</a>'
        );
      }).join('');

      searchAll.href = searchPageUrl + '?q=' + encodeURIComponent(query);
      searchResults.hidden = false;
      searchEmpty.hidden = true;
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer2);
        var query = searchInput.value.trim();

        if (query.length < 2) {
          searchHint.hidden = false;
          searchResults.hidden = true;
          searchEmpty.hidden = true;
          return;
        }

        searchTimer2 = setTimeout(function () {
          var url = suggestUrl +
            '?q=' + encodeURIComponent(query) +
            '&resources[type]=product' +
            '&resources[limit]=8' +
            '&resources[options][unavailable_products]=last';

          fetch(url)
            .then(function (response) { return response.json(); })
            .then(function (data) {
              if (searchInput.value.trim() !== query) return;
              searchHint.hidden = true;
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              renderResults(products, query);
            })
            .catch(function () {});
        }, 250);
      });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeSearch();
    }
  });

  /* ---------- Smart header: reveal on scroll up ---------- */
  var smartHeader = document.querySelector('.site-header--sticky');
  if (smartHeader) {
    var lastScrollY = window.scrollY;
    var headerHeight = smartHeader.offsetHeight || 120;
    var ticking = false;

    function onHeaderScroll() {
      var y = window.scrollY;

      if (y <= headerHeight + 40) {
        smartHeader.classList.remove('site-header--float', 'site-header--revealed');
      } else {
        smartHeader.classList.add('site-header--float');
        if (y < lastScrollY - 4) {
          smartHeader.classList.add('site-header--revealed');
        } else if (y > lastScrollY + 4) {
          smartHeader.classList.remove('site-header--revealed');
        }
      }

      lastScrollY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(onHeaderScroll);
      }
    }, { passive: true });
  }

  /* ---------- Footer accordions: open on desktop, collapsible on mobile ---------- */
  var footerAccordions = document.querySelectorAll('[data-footer-accordion]');
  if (footerAccordions.length) {
    var footerMq = window.matchMedia('(min-width: 750px)');

    function syncFooterAccordions() {
      footerAccordions.forEach(function (details) {
        if (footerMq.matches) {
          details.open = true;
        } else if (!details.dataset.userToggled) {
          details.open = false;
        }
      });
    }

    footerAccordions.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!footerMq.matches) details.dataset.userToggled = '1';
      });
    });

    syncFooterAccordions();
    if (footerMq.addEventListener) footerMq.addEventListener('change', syncFooterAccordions);
  }

  /* ---------- Announcement bar rotation ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;

    var current = 0;
    var interval = parseInt(bar.dataset.interval, 10) || 4000;

    setInterval(function () {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, interval);
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    var qtyWrap = (minus || plus).closest('[data-qty]');
    var input = qtyWrap && qtyWrap.querySelector('.qty__input');
    if (!input) return;

    var value = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10) || 0;
    input.value = plus ? value + 1 : Math.max(min, value - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart: auto submit on qty change ---------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var cartTimer;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () {
        cartForm.submit();
      }, 400);
    });
  }

  /* ---------- Collection: custom sort dropdown ---------- */
  var sortDropdown = document.querySelector('[data-sort-dropdown]');
  if (sortDropdown) {
    var sortToggle = sortDropdown.querySelector('[data-sort-toggle]');
    var sortMenu = sortDropdown.querySelector('.sort-dropdown__menu');

    sortToggle.addEventListener('click', function () {
      var willOpen = sortMenu.hidden;
      sortMenu.hidden = !willOpen;
      sortDropdown.classList.toggle('is-open', willOpen);
      sortToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    document.addEventListener('click', function (e) {
      if (!sortDropdown.contains(e.target)) {
        sortMenu.hidden = true;
        sortDropdown.classList.remove('is-open');
        sortToggle.setAttribute('aria-expanded', 'false');
      }
    });

    sortDropdown.querySelectorAll('[data-sort-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', btn.dataset.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Collection: filter drawer ---------- */
  var filterDrawer = document.querySelector('[data-filter-drawer]');
  if (filterDrawer) {
    var filterOpenBtn = document.querySelector('[data-filter-open]');
    var filterTimer;

    var openFilter = function () {
      clearTimeout(filterTimer);
      filterDrawer.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          filterDrawer.classList.add('is-open');
        });
      });
      document.body.style.overflow = 'hidden';
      if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', 'true');
    };

    var closeFilter = function () {
      if (filterDrawer.hidden) return;
      filterDrawer.classList.remove('is-open');
      filterTimer = setTimeout(function () {
        filterDrawer.hidden = true;
      }, 360);
      document.body.style.overflow = '';
      if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', 'false');
    };

    if (filterOpenBtn) filterOpenBtn.addEventListener('click', openFilter);
    filterDrawer.querySelectorAll('[data-filter-close]').forEach(function (el) {
      el.addEventListener('click', closeFilter);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeFilter();
    });

    var filterForm = filterDrawer.querySelector('[data-filter-form]');
    if (filterForm) {
      filterForm.addEventListener('submit', function () {
        filterForm.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (!input.value) input.disabled = true;
        });
      });
    }
  }

  /* ---------- Product form: variant selection ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsJson = productForm.querySelector('[data-variants-json]');
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var idInput = productForm.querySelector('[data-variant-id]');
    var addButton = productForm.querySelector('[data-add-button]');
    var addLabel = productForm.querySelector('[data-add-label]');
    var priceWrapper = document.querySelector('[data-price-wrapper]');
    var soldOutText = addLabel ? addLabel.textContent.trim() : '';

    var texts = {
      add: (window.themeStrings && window.themeStrings.addToCart) || 'Add to Cart',
      soldOut: (window.themeStrings && window.themeStrings.soldOut) || 'Sold Out',
      selectOptions: (window.themeStrings && window.themeStrings.selectOptions) || 'Select All Options'
    };

    function formatMoney(cents) {
      var format = window.themeMoneyFormat || '{{amount}}';
      var value = cents / 100;

      function withDelimiters(num, decimals, thousands, decimal) {
        var parts = num.toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return decimals > 0 ? parts.join(decimal) : parts[0];
      }

      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, placeholder) {
        switch (placeholder) {
          case 'amount_no_decimals':
            return withDelimiters(value, 0, ',', '.');
          case 'amount_with_comma_separator':
            return withDelimiters(value, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return withDelimiters(value, 0, '.', ',');
          default:
            return withDelimiters(value, 2, ',', '.');
        }
      });
    }

    function selectedOptions() {
      var opts = [];
      productForm.querySelectorAll('[data-option-index]').forEach(function (wrap) {
        var input = wrap.querySelector('select[data-option-input]') || wrap.querySelector('input[data-option-input]:checked');
        opts[parseInt(wrap.dataset.optionIndex, 10)] = input ? input.value : null;
      });
      return opts;
    }

    function updatePersonalization() {
      document.querySelectorAll('[data-personalization]').forEach(function (wrap) {
        var optionName = wrap.dataset.personalizationOption;
        var value = '';

        productForm.querySelectorAll('[data-option-name]').forEach(function (optWrap) {
          if (optWrap.dataset.optionName !== optionName) return;
          var select = optWrap.querySelector('[data-option-input]');
          if (select) value = select.value.trim().toLowerCase();
        });

        // Tetikleyici degerler tema ayarindan geliyor: urunler arasinda yazim birligi
        // yok ("Yes", "Name", "Custom Text"). Sabit listede tutulunca yeni bir yazim
        // cikinca metin kutusu hic acilmiyor ve siparis kisisellestirmesiz gidiyordu.
        var triggers = (wrap.dataset.personalizationTriggers || 'yes,evet,var')
          .split(',')
          .map(function (t) { return t.trim().toLowerCase(); })
          .filter(function (t) { return t !== ''; });
        var active = !themeIsNoneValue(value) && triggers.indexOf(value) !== -1;
        var input = wrap.querySelector('[data-personalization-input]');

        wrap.hidden = !active;
        if (input) {
          input.disabled = !active;
          input.required = active;
          if (!active) input.value = '';
        }
      });
    }

    function updateAccessoryColor() {
      var accWrap = document.querySelector('[data-accessory-color]');
      if (!accWrap) return;
      // Secenek adi urunden urune degisiyor ("Accessory", "ACCESSORIES",
      // "Other Accessories"). Tam esitlik yerine ad icinde arayip, aksesuar
      // secenegi birden fazlaysa herhangi birinde gercek secim varsa aciyoruz.
      var active = false;
      productForm.querySelectorAll('[data-option-name]').forEach(function (optWrap) {
        var n = (optWrap.dataset.optionName || '').toLowerCase();
        if (n.indexOf('accessor') === -1 && n.indexOf('aksesuar') === -1) return;
        var select = optWrap.querySelector('select[data-option-input]');
        var checked = optWrap.querySelector('input[data-option-input]:checked');
        var accValue = select ? select.value : (checked ? checked.value : '');
        if (!themeIsNoneValue(accValue)) active = true;
      });
      accWrap.hidden = !active;
      var accInput = accWrap.querySelector('[data-accessory-color-input]');
      if (accInput) accInput.disabled = !active;

      // Swatch modunda secili renk gizli alana ve etikete yaziliyor.
      var secili = accWrap.querySelector('[data-accessory-color-swatch]:checked');
      if (secili) {
        if (accInput && accInput.type === 'hidden') accInput.value = secili.value;
        var etiket = accWrap.querySelector('[data-accessory-color-label]');
        if (etiket) etiket.textContent = secili.value;
      }
    }

    // Renk swatch'ina tiklaninca gizli alani ve etiketi guncelle
    var accSwatchWrap = document.querySelector('[data-accessory-color]');
    if (accSwatchWrap) {
      accSwatchWrap.addEventListener('change', function (e) {
        if (!e.target.matches('[data-accessory-color-swatch]')) return;
        updateAccessoryColor();
      });
    }

    function findVariant(opts) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, i) {
          return option === opts[i];
        });
      });
    }

    function onVariantChange(skipUrl) {
      updatePersonalization();
      updateAccessoryColor();

      var opts = selectedOptions();
      var incomplete = opts.some(function (o) { return !o; });

      var stickyButton = document.querySelector('[data-atc-button]');

      if (incomplete) {
        // Müşteri henüz seçim yapmadı: buton aktif kalır, submit anında uyarılır
        if (idInput) idInput.value = '';
        if (addButton) addButton.disabled = false;
        if (addLabel) addLabel.textContent = texts.selectOptions;
        if (stickyButton) {
          stickyButton.disabled = false;
          stickyButton.textContent = texts.selectOptions;
        }
        return;
      }

      var variant = findVariant(opts);

      if (!variant) {
        if (idInput) idInput.value = '';
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = texts.soldOut;
        if (stickyButton) {
          stickyButton.disabled = true;
          stickyButton.textContent = texts.soldOut;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (addButton && addLabel) {
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? texts.add : texts.soldOut;
      }

      if (priceWrapper) {
        var current = priceWrapper.querySelector('.price__current');
        var compare = priceWrapper.querySelector('.price__compare');
        if (current) current.textContent = formatMoney(variant.price);
        if (compare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compare.textContent = formatMoney(variant.compare_at_price);
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }
      }

      var atcPrice = document.querySelector('[data-atc-price]');
      if (atcPrice) atcPrice.textContent = formatMoney(variant.price);
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? texts.add : texts.soldOut;
      }

      productForm.querySelectorAll('[data-option-index]').forEach(function (wrap) {
        var label = wrap.querySelector('[data-swatch-label]');
        if (!label) return;
        var checked = wrap.querySelector('input[data-option-input]:checked');
        if (checked) label.textContent = checked.value;
      });

      if (skipUrl) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    productForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      // Secim yapilinca o alandaki hata isaretini kaldir
      var errWrap = e.target.closest('[data-option-index]');
      if (errWrap) {
        errWrap.classList.remove('product-form__option--error', 'product-form__option--shake');
        var errMsg = errWrap.querySelector('.product-form__option-msg');
        if (errMsg) errMsg.remove();
      }
      onVariantChange();
    });

    updatePersonalization();
    updateAccessoryColor();
    // "None" varsayilanlari yuzunden tum secenekler acilista dolu olabilir:
    // fiyati/varyant id'sini bir kez degerlendir (URL'e variant parametresi ekleme)
    if (productForm.querySelector('[data-option-index]')) onVariantChange(true);
  }

  /* ---------- Mega menü: görselli kart accordion ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mega-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var card = toggle.closest('[data-mega-card]');
    var sub = card ? card.querySelector('[data-mega-sub]') : null;
    if (!sub) return;
    var acik = !sub.hidden;
    // Ayni mega menudeki diger kartlari kapat (tek seferde bir tanesi acik)
    var mega = card.closest('.mega-menu');
    if (mega) {
      mega.querySelectorAll('[data-mega-card]').forEach(function (other) {
        if (other === card) return;
        other.classList.remove('is-open');
        var s = other.querySelector('[data-mega-sub]');
        if (s) s.hidden = true;
        var b = other.querySelector('[data-mega-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    sub.hidden = acik;
    card.classList.toggle('is-open', !acik);
    toggle.setAttribute('aria-expanded', String(!acik));
  });

  // Mega menü kapaninca acik kartlari sifirla
  document.querySelectorAll('.site-nav__item--has-children').forEach(function (item) {
    item.addEventListener('mouseleave', function () {
      item.querySelectorAll('[data-mega-card].is-open').forEach(function (card) {
        card.classList.remove('is-open');
        var s = card.querySelector('[data-mega-sub]');
        if (s) s.hidden = true;
        var b = card.querySelector('[data-mega-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
  });

  /* ---------- Ürün kullanma videosu (YouTube pop-up) ---------- */
  var videoModal = document.querySelector('[data-video-modal]');
  if (videoModal) {
    var videoFrame = videoModal.querySelector('[data-video-frame]');

    function closeVideo() {
      videoModal.classList.remove('is-open');
      setTimeout(function () {
        videoModal.hidden = true;
        if (videoFrame) videoFrame.innerHTML = '';
      }, 250);
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-video-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.videoOpen;
        if (!id || !videoFrame) return;
        videoFrame.innerHTML =
          '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" ' +
          'title="video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; ' +
          'encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        videoModal.hidden = false;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { videoModal.classList.add('is-open'); });
        });
        document.body.style.overflow = 'hidden';
      });
    });

    videoModal.querySelectorAll('[data-video-close]').forEach(function (el) {
      el.addEventListener('click', closeVideo);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !videoModal.hidden) closeVideo();
    });
  }

  /* ---------- Çerez onay bandı ---------- */
  var cookieBanner = document.querySelector('[data-cookie-banner]');
  if (cookieBanner) {
    var COOKIE_KEY = 'pamuka:cookie-consent';
    var kayit = null;
    try { kayit = localStorage.getItem(COOKIE_KEY); } catch (e) {}

    function onayYaz(kabul) {
      // Onayi theme.liquid'deki erken script yazar (Customer Privacy API'si orada
      // loadFeatures ile aciliyor). Yedek olarak burada da localStorage'a yaziyoruz.
      if (window.pamukaConsent && window.pamukaConsent.set) {
        window.pamukaConsent.set(kabul);
      } else {
        try { localStorage.setItem(COOKIE_KEY, kabul ? 'all' : 'necessary'); } catch (e) {}
      }
      cookieBanner.classList.remove('is-open');
      setTimeout(function () { cookieBanner.hidden = true; }, 300);
    }

    if (!kayit) {
      setTimeout(function () {
        cookieBanner.hidden = false;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { cookieBanner.classList.add('is-open'); });
        });
      }, 900);
    }

    var kabulBtn = cookieBanner.querySelector('[data-cookie-accept]');
    var retBtn = cookieBanner.querySelector('[data-cookie-decline]');
    if (kabulBtn) kabulBtn.addEventListener('click', function () { onayYaz(true); });
    if (retBtn) retBtn.addEventListener('click', function () { onayYaz(false); });

    // Footer'daki "Cookie Preferences" bandi yeniden acar (UK pazarinda beklenen bir secenek)
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cookie-reopen]')) return;
      e.preventDefault();
      cookieBanner.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { cookieBanner.classList.add('is-open'); });
      });
    });
  }

  /* ---------- Product sliders (arrows) ---------- */
  document.querySelectorAll('[data-slider-wrap]').forEach(function (wrap) {
    var slider = wrap.querySelector('[data-slider]');
    var prev = wrap.querySelector('[data-slider-prev]');
    var next = wrap.querySelector('[data-slider-next]');
    if (!slider) return;

    function step() {
      var item = slider.querySelector('.product-slider__item');
      return item ? item.getBoundingClientRect().width + 18 : slider.clientWidth * 0.8;
    }

    if (prev) prev.addEventListener('click', function () { slider.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { slider.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  });

  /* ---------- Recently viewed products ---------- */
  var rvSection = document.querySelector('[data-recently-viewed]');
  if (rvSection) {
    var RV_KEY = 'pamuka:recently-viewed';
    var currentHandle = rvSection.dataset.currentHandle || '';
    var rvLimit = parseInt(rvSection.dataset.limit, 10) || 8;
    var handles = [];

    try {
      handles = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    } catch (e) { handles = []; }

    if (currentHandle) {
      handles = [currentHandle].concat(handles.filter(function (h) { return h !== currentHandle; })).slice(0, 13);
      try { localStorage.setItem(RV_KEY, JSON.stringify(handles)); } catch (e) {}
    }

    var toShow = handles.filter(function (h) { return h !== currentHandle; }).slice(0, rvLimit);
    var rvList = rvSection.querySelector('[data-rv-list]');

    if (toShow.length && rvList) {
      Promise.all(toShow.map(function (handle) {
        return fetch('/products/' + handle + '?view=card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (chunks) {
        var html = chunks.join('');
        if (!html.trim()) return;
        rvList.innerHTML = html;
        rvSection.hidden = false;
      });
    }
  }

  /* ---------- Product: lightbox ---------- */
  var lightbox = document.querySelector('[data-lightbox]');
  if (lightbox) {
    var lbSourcesEl = document.querySelector('[data-lightbox-sources]');
    var lbSources = [];
    try { lbSources = JSON.parse(lbSourcesEl ? lbSourcesEl.textContent : '[]'); } catch (e) {}

    var lbImg = lightbox.querySelector('[data-lightbox-img]');
    var lbMedia = lightbox.querySelector('[data-lightbox-media]');
    var lbCount = lightbox.querySelector('[data-lightbox-count]');
    var lbIndex = 0;
    var lbTimer;

    // Acik olan videoyu durdur ve DOM'dan kaldir (arka planda ses calmasin)
    var lbTemizle = function () {
      if (lbMedia) {
        lbMedia.innerHTML = '';
        lbMedia.hidden = true;
      }
    };

    var showLightboxImage = function (index) {
      if (!lbSources.length) return;
      lbIndex = (index + lbSources.length) % lbSources.length;
      var kaynak = lbSources[lbIndex];
      lbTemizle();

      if (kaynak.type === 'embed' && kaynak.url) {
        lbImg.hidden = true;
        lbImg.removeAttribute('src');
        lbImg.alt = '';
        lbMedia.hidden = false;
        lbMedia.innerHTML =
          '<iframe src="' + kaynak.url + '" title="' + (kaynak.alt || '') + '" ' +
          'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ' +
          'allowfullscreen frameborder="0"></iframe>';
      } else if (kaynak.type === 'video' && kaynak.url) {
        lbImg.hidden = true;
        lbImg.removeAttribute('src');
        lbImg.alt = '';
        lbMedia.hidden = false;
        var v = document.createElement('video');
        v.src = kaynak.url;
        if (kaynak.poster) v.poster = kaynak.poster;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        lbMedia.appendChild(v);
      } else {
        lbImg.hidden = false;
        lbImg.src = kaynak.url;
        lbImg.alt = kaynak.alt || '';
      }

      if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + lbSources.length;
    };

    var openLightbox = function (index) {
      if (!lbSources.length) return;
      clearTimeout(lbTimer);
      showLightboxImage(index);
      lightbox.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
      });
      document.body.style.overflow = 'hidden';
    };

    var closeLightbox = function () {
      if (lightbox.hidden) return;
      lightbox.classList.remove('is-open');
      lbTemizle();
      lbTimer = setTimeout(function () { lightbox.hidden = true; }, 280);
      document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-lightbox-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openLightbox(parseInt(btn.dataset.lightboxIndex, 10) || 0);
      });
    });

    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });
    var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    var lbNext = lightbox.querySelector('[data-lightbox-next]');
    if (lbPrev) lbPrev.addEventListener('click', function () { showLightboxImage(lbIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { showLightboxImage(lbIndex + 1); });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showLightboxImage(lbIndex - 1);
      if (e.key === 'ArrowRight') showLightboxImage(lbIndex + 1);
    });
  }

  /* ---------- Product: right info drawer (description/shipping/care) ---------- */
  var infoDrawer = document.querySelector('[data-info-drawer]');
  if (infoDrawer) {
    var infoTitle = infoDrawer.querySelector('[data-info-title]');
    var infoTimer;

    var closeInfo = function () {
      if (infoDrawer.hidden) return;
      infoDrawer.classList.remove('is-open');
      infoTimer = setTimeout(function () { infoDrawer.hidden = true; }, 360);
      document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-info-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.infoOpen;
        infoDrawer.querySelectorAll('[data-info-content]').forEach(function (panel) {
          var match = panel.dataset.infoContent === key;
          panel.hidden = !match;
          if (match && infoTitle) infoTitle.textContent = panel.dataset.infoLabel || '';
        });
        clearTimeout(infoTimer);
        infoDrawer.hidden = false;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { infoDrawer.classList.add('is-open'); });
        });
        document.body.style.overflow = 'hidden';
      });
    });

    infoDrawer.querySelectorAll('[data-info-close]').forEach(function (el) {
      el.addEventListener('click', closeInfo);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeInfo();
    });
  }

  /* ---------- Product: sticky add-to-cart bar ---------- */
  var atcBar = document.querySelector('[data-atc-bar]');
  var atcAnchor = document.querySelector('[data-atc-anchor]');
  if (atcBar && atcAnchor && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        atcBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      });
    }, { threshold: 0 });
    atcObserver.observe(atcAnchor);
  }

  /* ---------- Toast ---------- */
  var toastEl = document.querySelector('[data-toast]');
  var toastTimer;

  function showToast(message, isError) {
    if (!toastEl) return;
    var text = toastEl.querySelector('[data-toast-text]');
    if (text) text.textContent = message;
    toastEl.classList.toggle('toast--error', !!isError);
    clearTimeout(toastTimer);
    toastEl.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    });
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
      setTimeout(function () { toastEl.hidden = true; }, 300);
    }, 2400);
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartDrawerTimer;

  function openCartDrawer() {
    if (!cartDrawer) return;
    clearTimeout(cartDrawerTimer);
    cartDrawer.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { cartDrawer.classList.add('is-open'); });
    });
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer || cartDrawer.hidden) return;
    cartDrawer.classList.remove('is-open');
    cartDrawerTimer = setTimeout(function () { cartDrawer.hidden = true; }, 360);
    document.body.style.overflow = '';
  }

  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html || !cartDrawer) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (!fresh) return;
        var wasOpen = cartDrawer.classList.contains('is-open');
        cartDrawer.innerHTML = fresh.innerHTML;
        if (wasOpen) {
          cartDrawer.hidden = false;
          cartDrawer.classList.add('is-open');
        }
      })
      .catch(function () {});
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  var cdQtyTimers = {};

  if (cartDrawer) {
    // Header cart icon opens the drawer instead of navigating
    document.querySelectorAll('.header-actions__cart').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCartDrawer().then(openCartDrawer);
      });
    });

    // Delegated events survive drawer HTML refreshes
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) closeCartDrawer();

      var checkoutBtn = e.target.closest('[data-cd-checkout]');
      if (checkoutBtn) window.location.href = '/checkout';

      var minus = e.target.closest('[data-cd-minus]');
      var plus = e.target.closest('[data-cd-plus]');
      var remove = e.target.closest('[data-cd-remove]');
      var btn = minus || plus || remove;
      if (!btn || !cartDrawer.contains(btn)) return;

      var key = btn.dataset.key;
      var item = btn.closest('.cart-drawer__item');
      var qtyEl = item ? item.querySelector('.qty__value') : null;
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
      var newQty = remove ? 0 : (plus ? currentQty + 1 : Math.max(0, currentQty - 1));

      // Optimistic: sayiyi aninda guncelle, sunucuya debounce ile tek istek gonder.
      // Boylece hizli ard arda tiklamalar takilmadan birikir.
      if (qtyEl) qtyEl.textContent = newQty;
      if (newQty === 0 && item) item.style.opacity = '0.35';

      clearTimeout(cdQtyTimers[key]);
      cdQtyTimers[key] = setTimeout(function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart && typeof cart.item_count === 'number') {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            }
            return refreshCartDrawer();
          })
          .catch(function () { refreshCartDrawer(); });
      }, remove ? 0 : 350);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
  }

  /* ---------- Product form: AJAX add to cart + variant validation ---------- */
  var ajaxForm = document.querySelector('[data-product-form]');
  if (ajaxForm) {
    ajaxForm.addEventListener('submit', function (e) {
      e.preventDefault();

      // Variant selected? (item: no silent default selection)
      var missingWraps = [];
      ajaxForm.querySelectorAll('[data-option-index]').forEach(function (wrap) {
        var select = wrap.querySelector('select[data-option-input]');
        var radioChecked = wrap.querySelector('input[data-option-input]:checked');
        var value = select ? select.value : (radioChecked ? radioChecked.value : '');
        if (!value) missingWraps.push(wrap);
      });

      if (missingWraps.length) {
        var requiredText = (window.themeStrings && window.themeStrings.optionRequired) || 'Please select this option';
        missingWraps.forEach(function (wrap) {
          wrap.classList.add('product-form__option--error');
          if (!wrap.querySelector('.product-form__option-msg')) {
            var msg = document.createElement('span');
            msg.className = 'product-form__option-msg';
            msg.textContent = requiredText;
            wrap.appendChild(msg);
          }
          // Shake'i her basista yeniden tetikle
          wrap.classList.remove('product-form__option--shake');
          void wrap.offsetWidth;
          wrap.classList.add('product-form__option--shake');
        });
        if (navigator.vibrate) navigator.vibrate([80, 40, 80]);
        missingWraps[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var idInputEl = ajaxForm.querySelector('[data-variant-id]');
      if (!idInputEl || !idInputEl.value) {
        var unavailable = (window.themeStrings && window.themeStrings.unavailable) || 'This combination is unavailable';
        showToast(unavailable, true);
        return;
      }

      var submitBtn = ajaxForm.querySelector('[data-add-button]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(ajaxForm)
      })
        .then(function (r) {
          return r.json().then(function (json) { return { ok: r.ok, json: json }; });
        })
        .then(function (res) {
          if (!res.ok) {
            showToast(res.json.description || res.json.message || 'Error', true);
            return;
          }
          var added = (window.themeStrings && window.themeStrings.addedToCart) || 'Added to cart';
          showToast(added, false);
          updateCartCount();
          refreshCartDrawer().then(function () {
            setTimeout(openCartDrawer, 350);
          });
        })
        .catch(function () {})
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  /* ---------- Mobile product gallery arrows ---------- */
  var galleryWrap = document.querySelector('[data-gallery-wrap]');
  if (galleryWrap) {
    var gallery = galleryWrap.querySelector('[data-gallery]');
    var gPrev = galleryWrap.querySelector('[data-gallery-prev]');
    var gNext = galleryWrap.querySelector('[data-gallery-next]');
    var gItems = gallery ? gallery.querySelectorAll('.product-gallery__item') : [];

    if (gallery && gItems.length > 1 && gPrev && gNext) {
      // Kareler arasi bosluk masaustunde 12px, mobilde 10px. Sabit sayi yazmak
      // yerine gercek konumdan olcuyoruz, yoksa index kayiyor ve aktif kucuk
      // resim yanlis kareyi isaretliyor.
      function slideStep() {
        if (gItems.length > 1) {
          var fark = gItems[1].offsetLeft - gItems[0].offsetLeft;
          if (fark > 0) return fark;
        }
        return gItems[0].getBoundingClientRect().width;
      }

      function galleryIndex() {
        var step = slideStep();
        if (!step) return 0;
        var idx = Math.round((gallery.scrollLeft - gItems[0].offsetLeft) / step);
        if (idx < 0) idx = 0;
        if (idx > gItems.length - 1) idx = gItems.length - 1;
        return idx;
      }

      function updateGalleryNav() {
        // Arrows only matter in mobile carousel mode (horizontal scroll active)
        var horizontal = gallery.scrollWidth > gallery.clientWidth + 20;
        if (!horizontal) {
          gPrev.hidden = true;
          gNext.hidden = true;
          return;
        }
        var idx = galleryIndex();
        gPrev.hidden = idx <= 0;
        gNext.hidden = idx >= gItems.length - 1;
      }

      var thumbsWrap = galleryWrap.querySelector('[data-gallery-thumbs]');
      var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('[data-thumb-index]') : [];
      var thumbsPrev = galleryWrap.querySelector('[data-thumbs-prev]');
      var thumbsNext = galleryWrap.querySelector('[data-thumbs-next]');
      var sonAktif = -1;

      // Kucuk resim seridi cok fotografta tasiyor: oklari ve kenar solmasini
      // seridin gercek kaydirma durumuna gore ac/kapa.
      function updateThumbsNav() {
        if (!thumbsWrap) return;
        var sol = thumbsWrap.scrollLeft > 4;
        var sag = thumbsWrap.scrollLeft + thumbsWrap.clientWidth < thumbsWrap.scrollWidth - 4;
        thumbsWrap.classList.toggle('has-fade-start', sol);
        thumbsWrap.classList.toggle('has-fade-end', sag);
        if (thumbsPrev) thumbsPrev.hidden = !sol;
        if (thumbsNext) thumbsNext.hidden = !sag;
      }

      // Aktif kare degistiginde o kucuk resmi seridin ortasina getir, yoksa
      // 12 fotograflik seritte aktif kare gorunmez oluyor.
      function aktifKucukResmiGoster(idx) {
        if (!thumbsWrap || !thumbs[idx]) return;
        var t = thumbs[idx];
        var enFazla = thumbsWrap.scrollWidth - thumbsWrap.clientWidth;
        if (enFazla <= 0) return;
        var hedef = t.offsetLeft - (thumbsWrap.clientWidth - t.offsetWidth) / 2;
        if (hedef < 0) hedef = 0;
        if (hedef > enFazla) hedef = enFazla;
        if (Math.abs(thumbsWrap.scrollLeft - hedef) > 2) thumbsWrap.scrollLeft = hedef;
      }

      function thumbsKaydir(yon) {
        if (!thumbsWrap) return;
        thumbsWrap.scrollLeft += yon * Math.max(120, thumbsWrap.clientWidth * 0.8);
      }

      if (thumbsWrap) {
        var tTick = false;
        thumbsWrap.addEventListener('scroll', function () {
          if (tTick) return;
          tTick = true;
          requestAnimationFrame(function () {
            updateThumbsNav();
            tTick = false;
          });
        }, { passive: true });
        if (thumbsPrev) thumbsPrev.addEventListener('click', function () { thumbsKaydir(-1); });
        if (thumbsNext) thumbsNext.addEventListener('click', function () { thumbsKaydir(1); });
      }

      // Aktif kareyi isaretle + karusel yuksekligini o kareye gore ayarla.
      // Yatay bir video, dikey fotograflarin yuksekligini miras alip altinda
      // kocaman bosluk birakmasin diye yukseklik dinamik.
      function aktifKareyeUyarla() {
        var idx = galleryIndex();
        if (thumbs.length) {
          for (var i = 0; i < thumbs.length; i++) {
            thumbs[i].classList.toggle('is-active', i === idx);
          }
        }
        if (idx !== sonAktif) {
          sonAktif = idx;
          aktifKucukResmiGoster(idx);
        }
        var aktif = gItems[idx];
        if (aktif) {
          var h = aktif.getBoundingClientRect().height;
          if (h > 0) gallery.style.height = h + 'px';
        }
      }

      // TEK scroll dinleyicisi: daha once iki ayri dinleyici ayni rAF bayragini
      // paylastigi icin ikincisi (aktif thumb isaretleme) hicbir zaman calismiyordu.
      var gTick = false;
      gallery.addEventListener('scroll', function () {
        if (!gTick) {
          gTick = true;
          requestAnimationFrame(function () {
            updateGalleryNav();
            aktifKareyeUyarla();
            gTick = false;
          });
        }
      }, { passive: true });

      window.addEventListener('resize', function () {
        updateGalleryNav();
        aktifKareyeUyarla();
        updateThumbsNav();
      });

      gPrev.addEventListener('click', function () {
        gallery.scrollBy({ left: -slideStep(), behavior: 'smooth' });
      });
      gNext.addEventListener('click', function () {
        gallery.scrollBy({ left: slideStep(), behavior: 'smooth' });
      });

      if (thumbsWrap) {
        thumbsWrap.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-thumb-index]');
          if (!btn) return;
          var idx = parseInt(btn.dataset.thumbIndex, 10) || 0;
          var hedef = gItems[idx];
          if (!hedef) return;
          gallery.scrollTo({ left: hedef.offsetLeft - gItems[0].offsetLeft, behavior: 'smooth' });
        });
      }

      // Gorseller yuklendikce yukseklik degisebilir; ilk olcumu tazele.
      window.addEventListener('load', aktifKareyeUyarla);
      gallery.querySelectorAll('img, video').forEach(function (el) {
        el.addEventListener('loadedmetadata', aktifKareyeUyarla);
        el.addEventListener('load', aktifKareyeUyarla);
      });

      updateGalleryNav();
      aktifKareyeUyarla();
      updateThumbsNav();
      window.addEventListener('load', updateThumbsNav);
    }
  }

  /* ---------- Collection: dynamic multi-select category filter ---------- */
  var dynGrid = document.querySelector('[data-product-grid]');
  var dynForm = document.querySelector('[data-filter-form]');

  if (dynGrid && dynForm && dynForm.querySelector('[data-cat-filter]')) {
    var productCache = {};

    function fetchCollectionProducts(urlPath) {
      if (productCache[urlPath]) return Promise.resolve(productCache[urlPath]);
      var all = [];

      function pageFetch(page) {
        return fetch(urlPath + '/products.json?limit=250&page=' + page)
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) {
            var items = d.products || [];
            all = all.concat(items);
            if (items.length === 250 && page < 4) return pageFetch(page + 1);
            return all;
          });
      }

      return pageFetch(1).then(function (list) {
        productCache[urlPath] = list;
        return list;
      });
    }

    function dynMinPrice(p) {
      var min = Infinity;
      (p.variants || []).forEach(function (v) {
        var val = parseFloat(v.price);
        if (!isNaN(val) && val < min) min = val;
      });
      return min === Infinity ? 0 : min;
    }

    function dynAvailable(p) {
      return (p.variants || []).some(function (v) { return v.available; });
    }

    function dynOnSale(p) {
      return (p.variants || []).some(function (v) {
        var c = parseFloat(v.compare_at_price);
        return !isNaN(c) && c > parseFloat(v.price);
      });
    }

    function dynIsNew(p) {
      if (!p.created_at) return false;
      return (Date.now() - new Date(p.created_at).getTime()) < 45 * 86400 * 1000;
    }

    function dynPriceVaries(p) {
      var prices = (p.variants || []).map(function (v) { return v.price; });
      return prices.length > 1 && prices.some(function (x) { return x !== prices[0]; });
    }

    function dynRenderCard(p) {
      var strings = window.themeStrings || {};
      var img = p.images && p.images[0] ? p.images[0].src : '';
      if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=720';

      var cents = Math.round(dynMinPrice(p) * 100);
      var priceText = themeFormatMoney(cents);
      if (dynPriceVaries(p)) {
        priceText = (strings.fromPrice || 'From [p]').replace('[p]', priceText);
      }

      var badge = '';
      if (!dynAvailable(p)) {
        badge = '<span class="badge badge--soldout">' + (strings.soldOut || 'Sold Out') + '</span>';
      } else if (dynOnSale(p)) {
        badge = '<span class="badge badge--sale">' + (strings.badgeSale || 'SALE') + '</span>';
      } else if (dynIsNew(p)) {
        badge = '<span class="badge badge--new">' + (strings.badgeNew || 'NEW') + '</span>';
      }

      var title = (p.title || '').replace(/</g, '&lt;');

      return (
        '<div class="product-card">' +
          '<a href="/products/' + p.handle + '" class="product-card__media" tabindex="-1" aria-hidden="true">' +
            (img ? '<img src="' + img + '" alt="' + title + '" class="product-card__img" loading="lazy" width="540" height="720">' : '') +
            '<div class="product-card__badges">' + badge + '</div>' +
          '</a>' +
          '<div class="product-card__info">' +
            '<h3 class="product-card__title"><a href="/products/' + p.handle + '">' + title + '</a></h3>' +
            '<div class="price"><span class="price__current">' + priceText + '</span></div>' +
          '</div>' +
        '</div>'
      );
    }

    function applyDynamicFilter() {
      var cats = Array.prototype.slice.call(dynForm.querySelectorAll('[data-cat-filter]:checked'))
        .map(function (cb) { return cb.value; });
      if (!cats.length) return false;

      var priceInputs = dynForm.querySelectorAll('.filter-price input');
      var pMin = priceInputs[0] && priceInputs[0].value ? parseFloat(priceInputs[0].value) : null;
      var pMax = priceInputs[1] && priceInputs[1].value ? parseFloat(priceInputs[1].value) : null;

      var availChecked = Array.prototype.slice.call(dynForm.querySelectorAll('input[name*="availability"]:checked'))
        .map(function (b) { return b.value; });

      var sortRadio = dynForm.querySelector('input[name="sort_by"]:checked');
      var sortBy = sortRadio ? sortRadio.value : '';

      Promise.all(cats.map(fetchCollectionProducts)).then(function (lists) {
        var seen = {};
        var merged = [];
        lists.forEach(function (list) {
          list.forEach(function (p) {
            if (!seen[p.id]) { seen[p.id] = 1; merged.push(p); }
          });
        });

        if (availChecked.length === 1) {
          var wantAvail = availChecked[0] === '1';
          merged = merged.filter(function (p) { return dynAvailable(p) === wantAvail; });
        }
        if (pMin !== null) merged = merged.filter(function (p) { return dynMinPrice(p) >= pMin; });
        if (pMax !== null) merged = merged.filter(function (p) { return dynMinPrice(p) <= pMax; });

        switch (sortBy) {
          case 'price-ascending':
            merged.sort(function (a, b) { return dynMinPrice(a) - dynMinPrice(b); });
            break;
          case 'price-descending':
            merged.sort(function (a, b) { return dynMinPrice(b) - dynMinPrice(a); });
            break;
          case 'title-ascending':
            merged.sort(function (a, b) { return (a.title || '').localeCompare(b.title || ''); });
            break;
          case 'title-descending':
            merged.sort(function (a, b) { return (b.title || '').localeCompare(a.title || ''); });
            break;
          case 'created-descending':
            merged.sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); });
            break;
          case 'created-ascending':
            merged.sort(function (a, b) { return new Date(a.created_at) - new Date(b.created_at); });
            break;
        }

        if (merged.length) {
          dynGrid.innerHTML = merged.map(dynRenderCard).join('');
        } else {
          dynGrid.innerHTML = '<p class="collection-empty" style="grid-column: 1 / -1;">' + (dynGrid.dataset.emptyText || '') + '</p>';
        }

        var countEl = document.querySelector('[data-products-count]');
        if (countEl) {
          countEl.textContent = (countEl.dataset.countTemplate || '[n]').replace('[n]', merged.length);
        }

        var pag = document.querySelector('[data-pagination-wrap]');
        if (pag) pag.hidden = true;

        updateChosenLabel();

        var url = new URL(window.location.href);
        url.searchParams.set('cats', cats.map(encodeURIComponent).join(','));
        window.history.replaceState({}, '', url.toString());

        var closeBtn = document.querySelector('.filter-drawer [data-filter-close]');
        if (closeBtn) closeBtn.click();

        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      return true;
    }

    function updateChosenLabel() {
      var label = document.querySelector('[data-cat-count]');
      if (!label) return;
      var n = dynForm.querySelectorAll('[data-cat-filter]:checked').length;
      if (n > 0) {
        label.textContent = (label.dataset.chosenTemplate || '([n] chosen)').replace('[n]', n);
        label.hidden = false;
      } else {
        label.hidden = true;
      }
    }

    // Canlı sayaç: checkbox değiştikçe "(x chosen)" güncellenir
    dynForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-cat-filter]')) updateChosenLabel();
    });
    updateChosenLabel();

    dynForm.addEventListener('submit', function (e) {
      if (applyDynamicFilter()) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // URL'den durumu geri yükle (?cats=...)
    var dynParams = new URL(window.location.href).searchParams;
    var catsParam = dynParams.get('cats');
    if (catsParam) {
      var wanted = catsParam.split(',').map(decodeURIComponent);
      var anyChecked = false;
      dynForm.querySelectorAll('[data-cat-filter]').forEach(function (cb) {
        var match = wanted.indexOf(cb.value) !== -1;
        cb.checked = match;
        if (match) anyChecked = true;
      });
      if (anyChecked) {
        updateChosenLabel();
        applyDynamicFilter();
      }
    }
  }

  /* ---------- Customer: recover password toggle ---------- */
  var recoverLink = document.querySelector('[data-show-recover]');
  var recoverForm = document.querySelector('[data-recover-form]');
  if (recoverLink && recoverForm) {
    recoverLink.addEventListener('click', function (e) {
      e.preventDefault();
      recoverForm.hidden = !recoverForm.hidden;
    });
    if (window.location.hash === '#recover') recoverForm.hidden = false;
  }

  /* ---------- Customer: addresses ---------- */
  var addressToggle = document.querySelector('[data-toggle-address-form]');
  if (addressToggle) {
    addressToggle.addEventListener('click', function () {
      var form = document.querySelector('[data-address-new]');
      if (form) form.hidden = !form.hidden;
    });
  }

  document.querySelectorAll('[data-toggle-edit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.querySelector('[data-address-edit="' + btn.dataset.toggleEdit + '"]');
      if (form) form.hidden = !form.hidden;
    });
  });

  document.querySelectorAll('[data-address-edit] select[data-default], [data-address-new] select[data-default]').forEach(function (select) {
    var def = select.dataset.default;
    if (def) select.value = def;
  });
})();
